import { render, staticRenderFns } from "./customer_payments_two.vue?vue&type=template&id=2eb97b03&scoped=true&"
import script from "./customer_payments_two.vue?vue&type=script&lang=ts&"
export * from "./customer_payments_two.vue?vue&type=script&lang=ts&"
import style0 from "./customer_payments_two.vue?vue&type=style&index=0&id=2eb97b03&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb97b03",
  null
  
)

export default component.exports